import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const getSellersCatalog = state => state.models[name].sellers.results;
export const getCurSeller = state => state.models[name].seller;